<template>
  <div class="card rounded-default">
    <div class="card-body">
      <span class="badge mb-2" :class="`badge--${this.storeStatus}`">{{
        this.storeStatus
      }}</span>
      <h6 class="w-75">{{ storeDetails.name }}</h6>
      <div class="d-flex mt-3">
        <a :href="`https://${storeDetails?.store.domain}`" target="_blank">
          <span
            class="badge badge--blue"
            v-if="storeDetails?.store.domain !== ''"
            >https://{{ storeDetails?.store.domain }}</span
          >
        </a>
        <a href="#">
          <span
            class="badge badge--blue"
            v-if="storeDetails?.store.domain == ''"
            >NO SHOP URL</span
          >
        </a>
      </div>
      <div class="d-flex mt-3">
        <span
          class="badge badge--blue"
          v-for="(badge, index) in storeDetails.badges"
          :key="index"
          >{{ badge }}</span
        >
      </div>
      <div class="project-card-info">
        <div class="project-card-info__details">
          <p>Created at</p>
          <h6>{{ moment(storeDetails?.created_at).format('LLL') }}</h6>
        </div>
        <div class="project-card-info__details">
          <p>Last edit at</p>
          <h6>
            {{ moment(storeDetails?.updated_at).format('LLL') }}
          </h6>
        </div>
      </div>
      <div class="project-card-button mt-3 d-flex align-items-center">
        <Button
          :loading="false"
          :inactive="false"
          :variant="'primary'"
          :size="'md'"
          type="submit"
          name="editProject"
          btnClass="mr-3 mt-1"
          @click="navigateToURL(this.storeURL)"
        >
          <span class="">VIEW STORE</span></Button
        >
        <Button
          :loading="false"
          :inactive="false"
          :variant="'outline'"
          :size="'md'"
          type="submit"
          name="editWebsite"
          btnClass="mr-3 mt-1"
          @click="navigateToURL(`${this.storeURL}/login`)"
        >
          <span class="">LOGIN</span></Button
        >
        <Button
          v-if="showAdminButton"
          :loading="false"
          :inactive="false"
          :variant="'outline-danger'"
          :size="'md'"
          type="submit"
          name="editProject"
          btnClass="mt-1"
          @click="toggleModal(true)"
        >
          <svg
            class="icon cursor-pointer"
            width="24px"
            height="24px"
            viewBox="0 0 24 24"
          >
            <use xlink:href="/sprite.svg#icon-d-trash" />
          </svg>
          <span class="">DELETE STORE</span></Button
        >
      </div>
    </div>
  </div>
  <Modal
    :isVisible="modalIsVisible"
    @toggleModal="toggleModal"
    :storeName="storeDetails.name"
    :storeId="storeDetails.id"
  ></Modal>
</template>
<script>
import Button from '@/components/ui/Button'
import Modal from '@/components/dashboard/project/DeleteStoreModal'
import moment from 'moment'

export default {
  name: 'SingleStoreCard',
  components: { Button, Modal },
  props: {
    storeDetails: {
      type: Object,
    },
    showAdminButton: {
      type: Boolean,
    },
  },
  data() {
    return {
      moment: moment,
      modalIsVisible: false,
      storeStatus: this.storeDetails.status === 1 ? 'active' : 'danger',
      storeURL: this.storeDetails.store.full_domain,
    }
  },
  methods: {
    toggleModal(value) {
      this.modalIsVisible = value
    },
    navigateToURL(storeURL) {
      window.open(storeURL, '_blank')
    },
  },
}
</script>
<style lang="scss">
.min-h-60 {
  min-height: 60px;
}
.cursor-pointer {
  cursor: pointer;
}
</style>
